/**
 * 封装 axios 请求模块
 */
import router from "../router/index";

import { Notification, MessageBox, Message, Loading } from "element-ui"; //使用组件

import axios from "axios";

const request = axios.create({
  baseURL: "https://api.hnzyxsbh.com" // 基础路径
});

//3. 定义前置拦截器，请求拦截器，请求发送出去之前触发的
request.interceptors.request.use(
  config => {
    config.headers.token = sessionStorage.getItem("token");
    // console.log("config: " , config);
    return config;
  },
  error => {
    //报错的是时候抛出一个报错的信息
    return Promise.reject(error.response.status);
  }
);

var cion = 0;
//4. 定义后置拦截器,响应拦截器, 服务器响应回来数据之前触发，
request.interceptors.response.use(
  response => {
    //响应回来的数据操作
    return response;
  },
  error => {
    // console.log("响应回来的数据操作",error.response.status);
    if (error.response.status == 401) {
      cion = cion + 1;
      if (cion == 1) {
        MessageBox.confirm(
          "登录状态已过期，您可以继续留在该页面，或者重新登录",
          "系统提示",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            cion = 0; //避免重复触发

            router.push("/login");
          })
          .catch(() => {});
      }

      return;
    }
    //报错的是时候抛出一个报错的信息
    return Promise.reject(error);
  }
);

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js